import http from "../services/http";

export const apiGetDoctorProfile = async (filter = 1) => {
  try {
    const response = await http.get("/api/doctor/profile");
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
